function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { LifecycleEvent } from '@sky-uk-ott/client-lib-js-device';
import { Conviva } from '@sky-uk-ott/core-video-sdk-js-external-conviva';
import { TimedMetadataType } from '../../../core/player/player-engine-item';
import { InternalSessionState } from '../../../core/session-controller/internal-session-state';
import { buildTelemetryData } from '../../../core/telemetry/telemetry-utils';
import { ErrorReason, ErrorSeverity } from '../../../error';
import { sdkLogger } from '../../../logger';
import { AdBreakType, AdMetadataSource, SsaiStitcherType } from '../../adverts/common';
import { ReportingAddon } from '../reporting-addon';
import { AudioTrackChangeWorkaround } from './audio-track-change-workaround';
import { ConvivaAdInsights } from './conviva-ad-insights';
import { ConvivaCallbackFunctions } from './conviva-callback-functions';
import { getConvivaNetworkInformation } from './conviva-network-adapter';
import { extractNativeMessage, mapAdStreamTypeToConvivaAdPlayer, mapAdType, mapSessionStateToConvivaPlayerState, sanitizeGatewayUrl } from './metadata-helper';
import { CoreVideoInternal } from '../../../core-video-internal';
import { JsonUtils } from '../../../utils/json-utils';
import { RetryStates } from './conviva-addon.enums';
import { ObserverPriority } from '../../../utils/observables/observable.enums';
export { RetryStates } from './conviva-addon.enums';
export var ConvivaAddon = /*#__PURE__*/ function(ReportingAddon) {
    "use strict";
    _inherits(ConvivaAddon, ReportingAddon);
    function ConvivaAddon(convivaAddonConfig, convivaAddonInfo, session, sessionItem, metaAdapter, deviceStorage) {
        _class_call_check(this, ConvivaAddon);
        var _this;
        _this = _call_super(this, ConvivaAddon), _define_property(_this, "convivaAddonConfig", void 0), _define_property(_this, "convivaAddonInfo", void 0), _define_property(_this, "session", void 0), _define_property(_this, "sessionItem", void 0), _define_property(_this, "metaAdapter", void 0), _define_property(_this, "deviceStorage", void 0), _define_property(_this, "name", void 0), _define_property(_this, "convivaAdInsights", void 0), _define_property(_this, "convivaVideoAnalytics", void 0), _define_property(_this, "duration", void 0), _define_property(_this, "logger", void 0), _define_property(_this, "isPaused", void 0), _define_property(_this, "isVstSet", void 0), _define_property(_this, "isAppBackgrounded", void 0), _define_property(_this, "hasCheckedInitialState", void 0), _define_property(_this, "currentState", void 0), _define_property(_this, "lastCallTime", void 0), _define_property(_this, "activeAdBreak", void 0), _define_property(_this, "initialAdDataReceived", void 0), _define_property(_this, "audioTracks", void 0), _define_property(_this, "AudioTrackChangeWorkaround", void 0), _define_property(_this, "subtitleTracks", void 0), _define_property(_this, "notifyAppForegrounded", void 0), _define_property(_this, "notifyAppBackgrounded", void 0), _this.convivaAddonConfig = convivaAddonConfig, _this.convivaAddonInfo = convivaAddonInfo, _this.session = session, _this.sessionItem = sessionItem, _this.metaAdapter = metaAdapter, _this.deviceStorage = deviceStorage, _this.name = 'conviva', _this.convivaAdInsights = null, _this.convivaVideoAnalytics = null, _this.duration = 0, _this.logger = sdkLogger.withContext('Conviva'), _this.isPaused = false, _this.isVstSet = false, _this.isAppBackgrounded = false, _this.hasCheckedInitialState = false, _this.currentState = null, _this.lastCallTime = Date.now(), _this.activeAdBreak = null, _this.initialAdDataReceived = false, _this.audioTracks = new Array(), _this.AudioTrackChangeWorkaround = null, _this.subtitleTracks = new Array(), _this.notifyAppForegrounded = function() {
            if (_this.currentState === InternalSessionState.Stopping) {
                return;
            }
            _this.isAppBackgrounded = false;
            Conviva.Analytics.reportAppForegrounded();
            if (_this.isVstSet) {
                _this.reportUserWaitEnded();
            }
        }, _this.notifyAppBackgrounded = function() {
            if (_this.currentState === InternalSessionState.Stopping) {
                return;
            }
            _this.isAppBackgrounded = true;
            Conviva.Analytics.reportAppBackgrounded();
            if (_this.isVstSet) {
                _this.reportUserWaitStarted();
            }
        };
        _this.init();
        if (_this.convivaAddonConfig.enableAdInsights) {
            _this.logger.verbose('Ad insights enabled');
            _this.convivaAdInsights = new ConvivaAdInsights(_this.convivaVideoAnalytics, convivaAddonInfo, session, sessionItem, metaAdapter);
        } else {
            _this.logger.verbose('Ad insights not enabled');
        }
        _this.isAppBackgrounded = CoreVideoInternal.lifecycle.isAppBackgrounded();
        _this.listenToDeviceEvents();
        _this.listenToRetryEvents();
        _this.listenToPlayerEvents();
        _this.listenToAdEvents();
        _this.listenToTelemetryDataEvent();
        if (_this.convivaAddonConfig.enableAudioTrackChangeWorkaround) {
            _this.AudioTrackChangeWorkaround = new AudioTrackChangeWorkaround(_this.session, _this.convivaAdInsights, _this.convivaVideoAnalytics, _this.logger, _this.reportSeekEnded, _this.reportPlayerState);
        }
        return _this;
    }
    _create_class(ConvivaAddon, [
        {
            key: "destroy",
            value: function destroy() {
                var _this_convivaAdInsights;
                CoreVideoInternal.lifecycle.off(LifecycleEvent.Resume, this.notifyAppForegrounded);
                CoreVideoInternal.lifecycle.off(LifecycleEvent.Suspend, this.notifyAppBackgrounded);
                this.convivaVideoAnalytics.reportPlaybackEnded();
                this.logger.verbose('Report playback ended');
                this.convivaVideoAnalytics.release();
                (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.release();
                this.convivaAdInsights = null;
                this.convivaVideoAnalytics = null;
                this.duration = 0;
                this.currentState = null;
                if (this.AudioTrackChangeWorkaround) {
                    var _this_AudioTrackChangeWorkaround;
                    (_this_AudioTrackChangeWorkaround = this.AudioTrackChangeWorkaround) === null || _this_AudioTrackChangeWorkaround === void 0 ? void 0 : _this_AudioTrackChangeWorkaround.destroy();
                    this.AudioTrackChangeWorkaround = null;
                }
                this.logger.info('Release');
            }
        },
        {
            key: "init",
            value: function init() {
                this.configureConvivaAnalytics();
                this.initialiseConvivaAnalytics();
                this.configureDeviceMetadata();
                this.configureNetworkData();
                this.configurePlayerInfo();
                // initialiseMonitoringSession called as soon as the playback is requested but _before_ we receive data from the OVP request
                this.initialiseMonitoringSession();
            }
        },
        {
            key: "configureConvivaAnalytics",
            value: function configureConvivaAnalytics() {
                var config = {};
                var _this_convivaAddonConfig = this.convivaAddonConfig, customerKey = _this_convivaAddonConfig.customerKey, gatewayUrl = _this_convivaAddonConfig.gatewayUrl, isDebug = _this_convivaAddonConfig.isDebug;
                // isDebug should be false for Production
                if (isDebug) {
                    config[Conviva.Constants.LOG_LEVEL] = Conviva.Constants.LogLevel.DEBUG;
                }
                // gatewayUrl should be false for Production
                if (gatewayUrl) {
                    config[Conviva.Constants.GATEWAY_URL] = sanitizeGatewayUrl(gatewayUrl);
                }
                var callbackFunctions = new ConvivaCallbackFunctions(this.deviceStorage);
                if (Object.keys(config).length > 0) {
                    Conviva.Analytics.init(customerKey, callbackFunctions, config);
                } else {
                    Conviva.Analytics.init(customerKey, callbackFunctions);
                }
                this.logger.verbose('Init', customerKey, config);
            }
        },
        {
            key: "initialiseConvivaAnalytics",
            value: function initialiseConvivaAnalytics() {
                this.convivaVideoAnalytics = Conviva.Analytics.buildVideoAnalytics();
                this.logger.verbose('Build video analytics', this.convivaVideoAnalytics);
            }
        },
        {
            key: "configureDeviceMetadata",
            value: function configureDeviceMetadata() {
                var deviceMetadata = this.metaAdapter.adaptDeviceMetadata(this.convivaAddonInfo, this.convivaAddonConfig);
                Conviva.Analytics.setDeviceMetadata(deviceMetadata);
                this.logger.verbose('Set device metadata', JsonUtils.stringify(deviceMetadata));
            }
        },
        {
            key: "configureNetworkData",
            value: function configureNetworkData() {
                var networkInformation = getConvivaNetworkInformation(this.convivaAddonInfo.deviceNetworkStatus);
                if (!networkInformation) {
                    return;
                }
                Conviva.Analytics.reportDeviceMetric(Conviva.Constants.Network.CONNECTION_TYPE, networkInformation.connectionType);
                this.logger.verbose('Set network info', networkInformation);
            }
        },
        {
            key: "configurePlayerInfo",
            value: function configurePlayerInfo() {
                var playerInfo = this.metaAdapter.adaptPlayerInfo(this.convivaAddonInfo);
                this.convivaVideoAnalytics.setPlayerInfo(playerInfo);
                this.logger.verbose('Set player info', playerInfo);
            }
        },
        {
            key: "listenToPlayerEvents",
            value: function listenToPlayerEvents() {
                var _this = this;
                this.session.onBitrateChanged(function(param) {
                    var bitrateKbps = param.bitrateKbps, resolution = param.resolution;
                    _this.reportBitrate(bitrateKbps);
                    _this.reportVideoResolution(resolution);
                });
                this.session.onEncodedFrameRateChanged(function(frameRate) {
                    _this.setContentInfoEncodedFrameRate(frameRate);
                });
                this.session.onRenderedFrameRateChanged(function(frameRate) {
                    _this.reportRenderedFrameRate(frameRate);
                });
                this.session.onError(function(error) {
                    _this.reportError(error);
                });
                this.session.onPlaybackTimelineUpdated(function(param) {
                    var position = param.position, seekableRange = param.seekableRange;
                    _this.reportPlayHeadTime(position);
                    _this.setContentInfoDuration(seekableRange);
                });
                this.session.onPlayoutDataReceived(function(playoutData) {
                    _this.updateContentInfo(playoutData);
                });
                this.session.onSeekEnded(function() {
                    var _this_AudioTrackChangeWorkaround;
                    if (!((_this_AudioTrackChangeWorkaround = _this.AudioTrackChangeWorkaround) === null || _this_AudioTrackChangeWorkaround === void 0 ? void 0 : _this_AudioTrackChangeWorkaround.isChanging())) {
                        _this.reportSeekEnded();
                    }
                });
                this.session.onSeekStarted(function(position) {
                    var _this_AudioTrackChangeWorkaround;
                    if (!((_this_AudioTrackChangeWorkaround = _this.AudioTrackChangeWorkaround) === null || _this_AudioTrackChangeWorkaround === void 0 ? void 0 : _this_AudioTrackChangeWorkaround.isChanging())) {
                        _this.reportSeekStarted(position);
                    }
                });
                this.session.onCatchupSeek(function(catchupSeek) {
                    _this.reportCatchupSeek(catchupSeek);
                });
                this.session.onStateChanged(function(state) {
                    _this.checkStateElapsedTime(state);
                }, ObserverPriority.HIGH);
                this.session.onPinRequired(function() {
                    _this.reportUserWaitStarted();
                });
                this.session.onPinSuccess(function() {
                    _this.reportUserWaitEnded();
                });
                this.session.onUserWaitStarted(function() {
                    _this.reportUserWaitStarted();
                });
                this.session.onUserWaitEnded(function() {
                    _this.reportUserWaitEnded();
                });
                this.session.onCdnSwitch(function(event) {
                    var _event_toCdn, _event_toCdn1;
                    _this.reportError(event.switchError);
                    var _obj;
                    _this.convivaVideoAnalytics.setContentInfo((_obj = {}, _define_property(_obj, Conviva.Constants.STREAM_URL, ((_event_toCdn = event.toCdn) === null || _event_toCdn === void 0 ? void 0 : _event_toCdn.url.substring(0, Conviva.Constants.MAXIMUM_URL_LENGTH)) || ''), _define_property(_obj, Conviva.Constants.DEFAULT_RESOURCE, ((_event_toCdn1 = event.toCdn) === null || _event_toCdn1 === void 0 ? void 0 : _event_toCdn1.name) || ''), _obj));
                });
                this.session.onTimedMetadataReceived(function(timedMetadata) {
                    return _this.reportMediaRouteChange(timedMetadata);
                });
                this.session.onAvailableAudioTracksChanged(function(audioTracks) {
                    return _this.audioTracks = audioTracks;
                });
                this.session.onAudioTrackChanged(function(trackId) {
                    return _this.reportAudioTrackChange(trackId);
                });
                this.session.onAvailableSubtitlesTracksChanged(function(subtitleTracks) {
                    return _this.subtitleTracks = subtitleTracks;
                });
                this.session.onSubtitlesTrackChanged(function(track) {
                    var _track_id;
                    return _this.reportSubtitleTrackChange((_track_id = track === null || track === void 0 ? void 0 : track.id) !== null && _track_id !== void 0 ? _track_id : '');
                });
                this.session.onBitrateCapChanged(function(bitrateCap) {
                    return _this.reportBitrateCapApplied(bitrateCap);
                });
                this.session.onBitrateCapRequested(function(bitrateCap) {
                    return _this.reportBitrateCapRequested(bitrateCap);
                });
                this.session.onWarning(function(error) {
                    _this.reportError(error);
                });
                this.session.onEndOfEventMarkerReceived(function(eventTime) {
                    return _this.reportEndOfEventMarker(eventTime);
                });
                this.logger.verbose('Listen to player events');
            }
        },
        {
            key: "checkStateElapsedTime",
            value: function checkStateElapsedTime(state) {
                var _this = this;
                var _this_AudioTrackChangeWorkaround;
                var currentTime = Date.now();
                var elapsedTime = currentTime - this.lastCallTime;
                // If a paused state is called in under 200ms directly after a play state it will create a false playing state
                // This causes a long VST - Docs https://pulse.conviva.com/learning-center/content/ei_application/metric_dictionary/plays_1475846.html?Highlight=False%20Playing%20State#:~:text=No.-,Metric%20Adjustments,-Playing%20states
                if (this.isVstSet && !this.hasCheckedInitialState && state === InternalSessionState.Paused) {
                    this.hasCheckedInitialState = true;
                    if (elapsedTime <= 200) {
                        setTimeout(function() {
                            return _this.checkStateElapsedTime(state);
                        }, 200 - elapsedTime);
                        return;
                    }
                }
                if (!((_this_AudioTrackChangeWorkaround = this.AudioTrackChangeWorkaround) === null || _this_AudioTrackChangeWorkaround === void 0 ? void 0 : _this_AudioTrackChangeWorkaround.handleStateChangesDueToAudioTrackChange(state))) {
                    this.reportPlayerState(state);
                }
                this.checkInitialStates(state);
                this.lastCallTime = currentTime;
            }
        },
        {
            key: "listenToDeviceEvents",
            value: function listenToDeviceEvents() {
                CoreVideoInternal.lifecycle.on(LifecycleEvent.Resume, this.notifyAppForegrounded);
                CoreVideoInternal.lifecycle.on(LifecycleEvent.Suspend, this.notifyAppBackgrounded);
            }
        },
        {
            key: "listenToRetryEvents",
            value: function listenToRetryEvents() {
                var _this = this;
                this.session.onSessionRetryStarted(function(param) {
                    var code = param.code, message = param.message;
                    var _this_convivaVideoAnalytics;
                    (_this_convivaVideoAnalytics = _this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent(RetryStates.RetryStarted, {
                        error: "".concat(code, " - ").concat(message)
                    });
                });
                this.session.onSessionRetryEnded(function(param) {
                    var code = param.code, message = param.message;
                    var _this_convivaVideoAnalytics;
                    (_this_convivaVideoAnalytics = _this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent(RetryStates.RetrySucceeded, {
                        error: "".concat(code, " - ").concat(message)
                    });
                });
            }
        },
        {
            key: "initialiseMonitoringSession",
            value: function initialiseMonitoringSession() {
                // this method makes conviva session to start monitoring logs and
                // when passed a content info report as an argument will indirectly invoke
                // convivaVideoAnalytics.setContentInfo passing it the same content info report
                this.convivaVideoAnalytics.reportPlaybackRequested(this.buildInitialReport());
                this.logger.info('Session started');
            }
        },
        {
            key: "listenToAdEvents",
            value: function listenToAdEvents() {
                var _this = this;
                this.session.onAdBreakDataReceived(function(adBreaks) {
                    // If the first ad data we get is from the manifest, send out Ad Location Received event
                    if (!_this.initialAdDataReceived && adBreaks.find(function(adBreak) {
                        return adBreak.metadataSource === AdMetadataSource.Manifest;
                    })) {
                        _this.reportAdLocationReceived(adBreaks);
                    }
                    _this.initialAdDataReceived = true;
                });
                this.session.onAdTrackingReceived(function(adBreaks) {
                    var activeAdBreak = _this.activeAdBreak;
                    // If we started an ad with only partial data, we couldn't report ad break started then, do it now
                    if ((activeAdBreak === null || activeAdBreak === void 0 ? void 0 : activeAdBreak.metadataSource) === AdMetadataSource.Manifest) {
                        var updatedAdBreak = adBreaks.find(function(adBreak) {
                            return adBreak.id === activeAdBreak.id;
                        });
                        if (updatedAdBreak) {
                            _this.reportAdBreakStarted(updatedAdBreak);
                        }
                    }
                });
                this.session.onAdBreakFinished(function(adBreak) {
                    return _this.reportAdBreakEnded(adBreak);
                });
                this.session.onAdBreakStarted(function(adBreak) {
                    return _this.reportAdBreakStarted(adBreak);
                });
                this.logger.verbose('Listen to ad events');
            }
        },
        {
            key: "listenToTelemetryDataEvent",
            value: function listenToTelemetryDataEvent() {
                var _this = this;
                this.session.onTelemetry(function(event) {
                    return _this.reportTelemetryDataEvent(event);
                });
                this.logger.verbose('Listen to telemetry events');
            }
        },
        {
            key: "reportAudioTrackChange",
            value: function reportAudioTrackChange(trackId) {
                var _this_audioTracks, _this_convivaVideoAnalytics;
                var track = (_this_audioTracks = this.audioTracks) === null || _this_audioTracks === void 0 ? void 0 : _this_audioTracks.find(function(track) {
                    return track.id === trackId;
                });
                var _track_language, _track_audioCodec;
                var eventDetail = {
                    audioTrackId: trackId.toString(),
                    audioTrackLanguage: (_track_language = track === null || track === void 0 ? void 0 : track.language) !== null && _track_language !== void 0 ? _track_language : 'unknown',
                    audioCodec: (_track_audioCodec = track === null || track === void 0 ? void 0 : track.audioCodec) !== null && _track_audioCodec !== void 0 ? _track_audioCodec : 'unknown'
                };
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent(Conviva.Constants.Playback.AUDIO_LANGUAGE, eventDetail);
            }
        },
        {
            key: "reportMediaRouteChange",
            value: function reportMediaRouteChange(timedMetadata) {
                if (timedMetadata.type === TimedMetadataType.MediaRouteInfo) {
                    var _this_convivaVideoAnalytics;
                    var mediaRoute = timedMetadata.data;
                    (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent('MEDIA_ROUTE_CHANGED', {
                        mediaRoute: mediaRoute
                    });
                }
            }
        },
        {
            key: "reportSubtitleTrackChange",
            value: function reportSubtitleTrackChange(trackId) {
                var _this_subtitleTracks, _this_convivaVideoAnalytics;
                var track = (_this_subtitleTracks = this.subtitleTracks) === null || _this_subtitleTracks === void 0 ? void 0 : _this_subtitleTracks.find(function(track) {
                    return track.id === trackId;
                });
                var _track_language;
                var eventDetail = trackId ? {
                    subtitleTrackId: trackId.toString(),
                    subtitleTrackLanguage: (_track_language = track === null || track === void 0 ? void 0 : track.language) !== null && _track_language !== void 0 ? _track_language : 'unknown'
                } : {
                    subtitleTrackId: 'off',
                    subtitleTrackLanguage: 'off'
                };
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent(Conviva.Constants.Playback.SUBTITLES_LANGUAGE, eventDetail);
            }
        },
        {
            key: "reportBitrateCapRequested",
            value: function reportBitrateCapRequested(bitrateCap) {
                var _this_convivaVideoAnalytics;
                var currentBitrateCap = "".concat(bitrateCap.value);
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent('BITRATE_CAP_REQUESTED', {
                    value: currentBitrateCap,
                    reason: bitrateCap.reason
                });
            }
        },
        {
            key: "reportBitrateCapApplied",
            value: function reportBitrateCapApplied(bitrateCap) {
                var _this_convivaVideoAnalytics;
                var currentBitrateCap = "".concat(bitrateCap.value);
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent('BITRATE_CAP_APPLIED', {
                    value: currentBitrateCap,
                    reason: bitrateCap.reason
                });
            }
        },
        {
            key: "reportAdBreakEnded",
            value: function reportAdBreakEnded(adBreak) {
                this.activeAdBreak = null;
                this.convivaVideoAnalytics.reportAdBreakEnded();
                /**
         * https://gspcloud.atlassian.net/browse/VPTJS-13337
         * Conviva internally reset the state on ad->Main content transitions
         * After a CSAI preroll, conviva doesn't realize that we are still in a playing state
         * so we need to send them an extra one to avoid being stuck in an unknown state
         * This is unique behavior for ATV/FireTV as it is single timeline with both pre-roll and mainContent
         * here we re-enforce the state to playing if
         */ if (!adBreak) {
                    this.logger.verbose('AdBreak is null or undefined ', adBreak);
                } else if (adBreak.type === AdBreakType.Preroll && adBreak.ssaiStitcherType === SsaiStitcherType.None && this.currentState === InternalSessionState.Playing) {
                    this.reportPlayerState(InternalSessionState.Playing);
                }
                this.logger.verbose('Report ad break ended');
            }
        },
        {
            key: "reportTelemetryDataEvent",
            value: function reportTelemetryDataEvent(detail) {
                var telemetryReportingData = buildTelemetryData(detail);
                this.convivaVideoAnalytics.reportPlaybackEvent(detail.sessionMilestone, telemetryReportingData);
                this.logger.verbose('Report Telemetry data', telemetryReportingData);
            }
        },
        {
            key: "reportAdLocationReceived",
            value: function reportAdLocationReceived(adBreaks) {
                var _this_convivaVideoAnalytics;
                var eventDetailsPerAd = {};
                adBreaks.forEach(function(adBreak) {
                    var positionOffset = Number(adBreak.position);
                    adBreak.ads.forEach(function(ad) {
                        var details = {
                            position: positionOffset,
                            duration: ad.expectedDuration
                        };
                        positionOffset += ad.expectedDuration;
                        eventDetailsPerAd["".concat(ad.id)] = JsonUtils.stringify(details);
                    });
                });
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent('Ad_Location_Received', eventDetailsPerAd);
            }
        },
        {
            key: "reportAdBreakStarted",
            value: function reportAdBreakStarted(adBreak) {
                this.activeAdBreak = adBreak;
                // Don't report partial ads/ad breaks
                if (adBreak.metadataSource === AdMetadataSource.Manifest) {
                    return;
                }
                var adPlayer = mapAdStreamTypeToConvivaAdPlayer(adBreak.streamType);
                var adType = mapAdType(adBreak.streamType);
                this.convivaVideoAnalytics.reportAdBreakStarted(adType, adPlayer);
                this.logger.verbose('Report ad break started', adType, adPlayer);
            }
        },
        {
            key: "reportBitrate",
            value: function reportBitrate(bitrateKbps) {
                var _this_convivaVideoAnalytics, _this_convivaAdInsights;
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.BITRATE, bitrateKbps);
                (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.reportBitrate(bitrateKbps);
                this.logger.verbose('Report bitrate', bitrateKbps);
            }
        },
        {
            key: "reportRenderedFrameRate",
            value: function reportRenderedFrameRate(frameRate) {
                var _this_convivaVideoAnalytics;
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.RENDERED_FRAMERATE, frameRate);
                this.logger.verbose('Report rendered frame rate', frameRate);
            }
        },
        {
            key: "reportEndOfEventMarker",
            value: function reportEndOfEventMarker(eventTime) {
                var _this_convivaVideoAnalytics;
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent('END_OF_EVENT_MARKER_RECEIVED', {
                    eventTime: eventTime.toString()
                });
            }
        },
        {
            key: "reportErrorAndEventMessage",
            value: function reportErrorAndEventMessage(error, message, severity) {
                if (!this.convivaVideoAnalytics) {
                    this.logger.warn("Cannot report error ".concat(error.code, " - ").concat(error.message, " as convivaVideoAnalytics is not set"));
                    return;
                }
                var parameters = error.parameters, restError = _object_without_properties(error, [
                    "parameters"
                ]);
                var reportMessage = "".concat(error.code, " - ").concat(message);
                this.convivaVideoAnalytics.reportPlaybackError(reportMessage, severity);
                this.convivaVideoAnalytics.reportPlaybackEvent('ERROR_DETAILS', restError);
                if (parameters) {
                    this.convivaVideoAnalytics.reportPlaybackEvent('ERROR_PARAMETERS', parameters);
                }
            }
        },
        {
            key: "reportError",
            value: function reportError(error) {
                var code = error.code, severity = error.severity, originalSeverity = error.originalSeverity, reason = error.reason;
                if (this.shouldReportError(code)) {
                    var message = error.message;
                    var cause = error.cause;
                    if (reason === ErrorReason.VizioUnrecoverablePipelineErrorDecode) {
                        message = "".concat(message, " ").concat(reason);
                    }
                    var nativeMessage = extractNativeMessage(cause);
                    if (nativeMessage) {
                        message = "".concat(message, ": ").concat(nativeMessage);
                    }
                    switch(severity){
                        case ErrorSeverity.Fatal:
                            var _this_convivaAdInsights;
                            this.reportErrorAndEventMessage(error, message, Conviva.Constants.ErrorSeverity.FATAL);
                            (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.reportFailed(code);
                            this.logger.error('Report fatal error', code, message);
                            break;
                        case ErrorSeverity.Warning:
                            this.reportErrorAndEventMessage(error, message, Conviva.Constants.ErrorSeverity.WARNING);
                            if (originalSeverity === ErrorSeverity.Fatal) {
                                var _this_convivaAdInsights1;
                                (_this_convivaAdInsights1 = this.convivaAdInsights) === null || _this_convivaAdInsights1 === void 0 ? void 0 : _this_convivaAdInsights1.reportFailed(code);
                            }
                            this.logger.warn('Report non-fatal error', code, message);
                            break;
                    }
                }
            }
        },
        {
            key: "reportPlayerState",
            value: function reportPlayerState(state) {
                this.currentState = state;
                if (!this.initialAdDataReceived && state === InternalSessionState.Loading) {
                    var _this_convivaVideoAnalytics, _this_convivaAdInsights;
                    (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.PLAYER_STATE, Conviva.Constants.PlayerState.NOT_MONITORED);
                    (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.reportState(Conviva.Constants.PlayerState.NOT_MONITORED);
                } else {
                    var convivaPlayerState = mapSessionStateToConvivaPlayerState(state);
                    if (convivaPlayerState) {
                        var _this_convivaVideoAnalytics1, _this_convivaAdInsights1;
                        if (this.isAppBackgrounded && convivaPlayerState === Conviva.Constants.PlayerState.STOPPED) {
                            this.reportUserWaitEnded();
                            this.isAppBackgrounded = false;
                        }
                        (_this_convivaVideoAnalytics1 = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics1 === void 0 ? void 0 : _this_convivaVideoAnalytics1.reportPlaybackMetric(Conviva.Constants.Playback.PLAYER_STATE, convivaPlayerState);
                        (_this_convivaAdInsights1 = this.convivaAdInsights) === null || _this_convivaAdInsights1 === void 0 ? void 0 : _this_convivaAdInsights1.reportState(convivaPlayerState);
                        this.logger.verbose('Report player state', convivaPlayerState);
                    }
                }
            }
        },
        {
            key: "checkInitialStates",
            value: function checkInitialStates(state) {
                if (!this.isVstSet) {
                    if (state === InternalSessionState.Paused) {
                        var _this_convivaVideoAnalytics;
                        this.isPaused = true;
                        (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackEvent('Autoplay_Disabled');
                        this.reportUserWaitStarted();
                    }
                    if (state === InternalSessionState.Playing) {
                        this.isVstSet = true;
                        if (this.isAppBackgrounded) {
                            var _this_convivaVideoAnalytics1;
                            (_this_convivaVideoAnalytics1 = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics1 === void 0 ? void 0 : _this_convivaVideoAnalytics1.reportPlaybackEvent('Backgrounded_Transition');
                            this.logger.verbose('App is backgrounded when VST is set it should remain in a reportUserWaitStarted state');
                            this.reportUserWaitStarted();
                        }
                        if (this.isPaused) {
                            this.reportUserWaitEnded();
                        }
                    }
                }
            }
        },
        {
            key: "reportPlayHeadTime",
            value: function reportPlayHeadTime(position) {
                var _this_convivaVideoAnalytics, _this_convivaAdInsights;
                var positionMs = position * 1000;
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.PLAY_HEAD_TIME, positionMs);
                (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.reportPlayHeadTime(positionMs);
                this.logger.verbose('Report play head time', positionMs);
            }
        },
        {
            key: "reportSeekStarted",
            value: function reportSeekStarted(position) {
                var _this_convivaVideoAnalytics, _this_convivaAdInsights;
                var positionMs = position * 1000;
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.SEEK_STARTED, positionMs);
                (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.reportSeekStarted(positionMs);
                this.logger.verbose('Report seek started', positionMs);
            }
        },
        {
            key: "reportSeekEnded",
            value: function reportSeekEnded() {
                var _this_convivaVideoAnalytics, _this_convivaAdInsights;
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.SEEK_ENDED);
                (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.reportSeekEnded();
                this.logger.verbose('Report seek ended');
            }
        },
        {
            key: "reportCatchupSeek",
            value: function reportCatchupSeek(catchupSeek) {
                var customEvent = 'CATCHUP_SEEK';
                var eventDetail = {
                    adsSkipped: catchupSeek.adsSkipped.toString(),
                    index: catchupSeek.index.toString(),
                    duration: catchupSeek.duration.toString()
                };
                this.convivaVideoAnalytics.reportPlaybackEvent(customEvent, eventDetail);
                this.logger.verbose('Report catchup seek');
            }
        },
        {
            key: "reportVideoResolution",
            value: function reportVideoResolution(resolution) {
                if (resolution) {
                    var _this_convivaVideoAnalytics, _this_convivaAdInsights;
                    var width = resolution.width, height = resolution.height;
                    (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.reportPlaybackMetric(Conviva.Constants.Playback.RESOLUTION, width, height);
                    (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.reportVideoResolution(resolution);
                    this.logger.verbose('Report video resolution', width, height);
                }
            }
        },
        {
            key: "reportUserWaitEnded",
            value: function reportUserWaitEnded() {
                this.convivaVideoAnalytics.reportPlaybackEvent(Conviva.Constants.Events.USER_WAIT_ENDED);
                this.logger.verbose('Report user wait ended');
            }
        },
        {
            key: "reportUserWaitStarted",
            value: function reportUserWaitStarted() {
                this.convivaVideoAnalytics.reportPlaybackEvent(Conviva.Constants.Events.USER_WAIT_STARTED);
                this.logger.verbose('Report user wait started');
            }
        },
        {
            key: "shouldReportError",
            value: function shouldReportError(errorCode) {
                var isMutedErrorCode = this.convivaAddonConfig.mutedErrorCodes.some(function(code) {
                    return code === errorCode;
                });
                return !isMutedErrorCode;
            }
        },
        {
            key: "setContentInfoEncodedFrameRate",
            value: function setContentInfoEncodedFrameRate(frameRate) {
                this.convivaVideoAnalytics.setContentInfo(_define_property({}, Conviva.Constants.ENCODED_FRAMERATE, frameRate));
                this.logger.verbose('Set encoded frame rate', frameRate);
            }
        },
        {
            key: "setContentInfoDuration",
            value: function setContentInfoDuration(seekableRange) {
                var hasDurationChanged = seekableRange && seekableRange.end !== this.duration;
                if (hasDurationChanged) {
                    var duration = this.metaAdapter.getDuration(seekableRange);
                    this.convivaVideoAnalytics.setContentInfo(_define_property({}, Conviva.Constants.DURATION, duration));
                    this.duration = duration;
                    this.logger.verbose('Set content info - duration', this.duration);
                }
            }
        },
        {
            key: "buildInitialReport",
            value: function buildInitialReport() {
                return this.metaAdapter.adaptInitialReport(this.sessionItem, this.convivaAddonInfo, this.session);
            }
        },
        {
            key: "buildUpdatedReport",
            value: function buildUpdatedReport(playoutData) {
                return this.metaAdapter.adaptContentTags(this.sessionItem, playoutData, this.convivaAddonInfo, this.session);
            }
        },
        {
            key: "updateContentInfo",
            value: function updateContentInfo(playoutData) {
                var _this_convivaAdInsights, _this_convivaVideoAnalytics;
                (_this_convivaAdInsights = this.convivaAdInsights) === null || _this_convivaAdInsights === void 0 ? void 0 : _this_convivaAdInsights.updatePlayoutData(playoutData);
                (_this_convivaVideoAnalytics = this.convivaVideoAnalytics) === null || _this_convivaVideoAnalytics === void 0 ? void 0 : _this_convivaVideoAnalytics.setContentInfo(this.buildUpdatedReport(playoutData));
            }
        }
    ]);
    return ConvivaAddon;
}(ReportingAddon);

//# sourceMappingURL=conviva-addon.js.map